import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { initializeFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

const gaMeasurementId = (import.meta.env.VITE_GA_MEASUREMENT_ID ?? '').trim();
const gaAllowedHosts = (import.meta.env.VITE_GA_ALLOWED_HOSTS ?? 'kodacare.pet,www.kodacare.pet,app.kodacare.pet')
  .split(',')
  .map(host => host.trim().toLowerCase())
  .filter(Boolean);
const currentHost = typeof window !== 'undefined' ? window.location.hostname.toLowerCase() : '';
const shouldEnableAnalytics =
  typeof window !== 'undefined'
  && import.meta.env.PROD
  && Boolean(gaMeasurementId)
  && gaAllowedHosts.includes(currentHost);

const firebaseConfig = {
  apiKey: 'AIzaSyCRxWKCyfMsvDV2k2vdJSUMLW9UDlS_Cuo',
  authDomain: import.meta.env.PROD ? 'app.kodacare.pet' : 'kodacare-app.web.app',
  projectId: 'kodacare-d0b26',
  storageBucket: 'kodacare-d0b26.firebasestorage.app',
  messagingSenderId: '969641759885',
  appId: '1:969641759885:web:26dc25b3b9d77ee6d67ec4',
  ...(gaMeasurementId ? { measurementId: gaMeasurementId } : {}),
};

export const app = initializeApp(firebaseConfig);

// Analytics (optional — only available in browser)
export const analytics = shouldEnableAnalytics ? getAnalytics(app) : null;

// Auth instance — explicitly set LOCAL persistence so sessions survive
// Android PWA process restarts (the Firebase default is also LOCAL, but
// this guards against any prior session that may have used SESSION persistence).
export const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence).catch(console.error);
export const storage = getStorage(app);

// Firestore — default in-memory cache (no IndexedDB persistence).
// persistentLocalCache uses IndexedDB which deadlocks silently on Android
// Chrome/WebView, causing all writes to queue forever and never resolve.
// Real-time onSnapshot listeners mean data loads quickly on reconnect anyway.
export const db = initializeFirestore(app, {
  experimentalAutoDetectLongPolling: true,
});
